import React from "react";
import RFField from "../../../components/Form/RFField";
import { useRFFormContext } from "../../../components/Form/RFForm";
import { useEffect } from "react";

const BizonylatTombRaktarField = ({ onChange, raktarid, inaktiv, cegadatid, options }) => {
  const { change } = useRFFormContext();

  useEffect(() => {
    change("raktarid", raktarid);
  }, [raktarid]);

  return (
    <RFField
      type="select"
      name="raktarid"
      id="raktarid"
      label={'Raktár:' + (!inaktiv ? ' *' : '')}
      disabled={inaktiv || !cegadatid}
      defaultSelect={<option value="">Válassz raktárat...</option>}
      selectOptions={options}
      value={raktarid}
      onChange={onChange}
      required={!inaktiv}
    />
  );
};

export default BizonylatTombRaktarField;
